import axios from 'axios';
import { BASE_URL } from '@/globalConfig';

const servise = axios.create({
  // baseURL: 'http://58.20.55.73:54361/api',
  baseURL: `/api`,
  timeout: '60000',
});

servise.interceptors.request.use(
  (config) => {
    return config;
  },
  (err) => Promise.reject(err)
);

servise.interceptors.response.use(
  (response) => {
    if (response.status === 200) {
      const res = response.data;
      if (res.code !== 200) {
        console.log('请求失败 :>> ');
      }
      return res;
    } else {
      console.log('请求错误 :>> ');

      return Promise.reject(response);
    }
  },
  (error) => {
    console.log('服务错误 :>> ', error);

    return Promise.reject(error);
  }
);
export default servise;
